module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAsElEQVQokaXQMU4CQRiG4YfN6GG4iHRAKDkAjS2JB6DAjmSrDdQcQTt7jY0NnVY2XsBEJErhQJYJkt3lSyaTL++8yT9/a5YXE4xxqVrWuM1qSuLbm6ymtMtF1kACZfETy3jDYzzH2IE4xxCL2K/Q+YcJJbGHV3Rjn55gWrO8+K30qSRnLeenqXjfwLsL6KPtb1HPJfiBEd4TaYNVwDdeEviEwRFpn5D0NzzgGl+nZt0C84Ekk5Q1m0oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mseeage_icon.png
// module id = S2l/
// module chunks = 1